<input
  #textInput
  matInput
  class="date-input"
  [placeholder]="placeholder || 'MM/DD/YYYY'"
  [id]="id"
  [name]="id"
  [required]="required"
  [max]="max"
  [min]="min"
  [maskito]="dateMask"
  [(ngModel)]="dateValue"
  [disabled]="disabled"
  (keyup)="onTextInputChange($event, textInput)"
  (change)="onTextInputChange($event, textInput)"
/>

<input
  #datepickerInput
  style="display: none"
  [max]="max"
  [min]="min"
  [(ngModel)]="datePickerValue"
  [matDatepicker]="picker"
  [disabled]="disabled"
  (dateInput)="onDatePickerChange('input', $event)"
  (dateChange)="onDatePickerChange('change', $event)"
/>
<mat-datepicker touchUi #picker [startView]="startView"></mat-datepicker>
<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
